var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguageukenglish20X20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#04247B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.8 3.75a9.96 9.96 0 0 1 2.06 4.56l-3.89 1.82 3.85 1.79a9.96 9.96 0 0 1-2.16 4.51l-7.6-3.55-7.69 3.59a9.96 9.96 0 0 1-2.18-4.5l3.95-1.84L.15 8.26a9.96 9.96 0 0 1 2.07-4.55l7.84 3.66 7.75-3.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE152A",
    d: "M18.92 5.48c.15.3.29.6.4.9l-7.86 3.68 7.83 3.64c-.12.32-.26.62-.42.91l-8.59-4-9.04 4.21c-.16-.29-.3-.59-.44-.9l8.3-3.86-8.34-3.9c.13-.3.27-.6.43-.9l9.1 4.24 8.63-4.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.54 7a10 10 0 0 1 0 6H13v6.54a10 10 0 0 1-6 0V13H.46a10 10 0 0 1 0-6H7V.46a10 10 0 0 1 6 0V7h6.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE152A",
    d: "M19.8 8a10.05 10.05 0 0 1 0 4H12v7.8a10.05 10.05 0 0 1-4 0V12H.2a10.05 10.05 0 0 1 0-4H8V.2a10.05 10.05 0 0 1 4 0V8h7.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageukenglish20X20);
export default __webpack_public_path__ + "static/media/languageukenglish20x20.d4716d49ce0998ec55a3b656573b3acc.svg";
export { ForwardRef as ReactComponent };